import { render, staticRenderFns } from "./BaseListItem.vue?vue&type=template&id=c4710f58&scoped=true&"
import script from "./BaseListItem.vue?vue&type=script&lang=js&"
export * from "./BaseListItem.vue?vue&type=script&lang=js&"
import style0 from "./BaseListItem.vue?vue&type=style&index=0&id=c4710f58&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4710f58",
  null
  
)

export default component.exports